var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgSavedFiltersIconMultiColor = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#savedFiltersIconMultiColor_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "var(--dlMultiColorSecondary)",
  d: "M15.333 5.68h-5.026L8.636.439a.696.696 0 0 0-1.272 0L5.694 5.68H.666a.667.667 0 0 0-.4 1.2L4.28 9.947 2.6 15.103a.667.667 0 0 0 1.027.745L8 12.667l4.373 3.177a.667.667 0 0 0 1.027-.745l-1.675-5.151 4.014-3.067a.667.667 0 0 0-.4-1.2l-.006-.001Z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "savedFiltersIconMultiColor_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h16v16H0z"
})))));
export default SvgSavedFiltersIconMultiColor;